

const quizArray = [
'You would remember your employees birthdays.',
'You would carry the heavy thing for the women because she\'s a women and men are stronger.',
'You would throw the snails you found in your letterbox into the neighbours property because killing them is icky.',
'You would feel comfortable posing nude for a sculpting class.',
'You would refuse a winning lotto ticket if it meant you\'d lose a patella.',
'Liver patté is just sickening and wrong.',
]

export default quizArray;




